import { z } from "zod";

export const changeEmailSchema = z
    .object({
        email: z.email({ message: "Please enter a valid email" }),
        emailRepeat: z.string({ message: "Please repeat your email" }),
    })
    .refine((data) => data.email === data.emailRepeat, {
        message: "Emails do not match",
        path: ["emailRepeat"],
    });

export const changeUserInfoSchema = z
    .object({
        username: z
            .string({ message: "Username is required" })
            .min(3, { message: "Username must be at least 3 characters long" })
            .max(15, {
                message: "Username must be at most 15 characters long",
            }),
        legalName: z
            .string({ message: "Legal name is required" })
            .min(1, { message: "Legal name is required" }),
        country: z
            .string({ message: "Country is required" })
            // .min(1, { message: "Country name is required" })
            .optional(),
        postalCode: z
            .string({ message: "Postal code is required" })
            // .min(1, { message: "Postal code is required" })
            .regex(/^\d*$/, { message: "Must be a number" })
            .optional(),
        city: z
            .string({ message: "City is required" })
            // .min(1, { message: "City is required" })
            .optional(),
        region: z
            .string({ message: "Region is required" })
            // .min(1, { message: "Region is required" })
            .optional(),
        street: z
            .string({ message: "Street is required" })
            // .min(1, { message: "Street is required" })
            .optional(),
        company: z.boolean(),
        companyName: z.string().optional(),
        vatNumber: z.string().optional(),
    })
    .superRefine((data, ctx) => {
        const fields = [
            "country",
            "postalCode",
            "city",
            "region",
            "street",
        ] as const;
        const isEmpty = (v?: string | null) => !v || v.length === 0;

        if (data.company) {
            const missing = fields.filter((f) => isEmpty(data[f]));
            if (missing.length > 0) {
                for (const f of fields) {
                    ctx.addIssue({
                        code: "custom",
                        message: "Billing address is required for companies",
                        path: [f],
                    });
                }
            }
            if (!data.companyName || data.companyName.length === 0) {
                ctx.addIssue({
                    code: "custom",
                    message: "Company name is required",
                    path: ["companyName"],
                });
            }
            if (!data.vatNumber || data.vatNumber.length === 0) {
                ctx.addIssue({
                    code: "custom",
                    message: "VAT number is required",
                    path: ["vatNumber"],
                });
            }
        }

        const anySet = fields.some((f) => !isEmpty(data[f]));
        const allSet = fields.every((f) => !isEmpty(data[f]));
        if (anySet && !allSet) {
            for (const f of fields) {
                ctx.addIssue({
                    code: "custom",
                    message:
                        "Please fill out all billing address fields or leave them all empty.",
                    path: [f],
                });
            }
        }
    });
/*.refine(
        (data) =>
            data.company ? !!data.vatNumber && data.vatNumber.length > 0 : true,
        {
            message: "VAT number is required",
            path: ["vatNumber"],
        },
    );*/

export const changeNotificationsSchema = z.object({
    emailOnLogin: z.boolean().optional(),
});

export const changePasswordSchema = z
    .object({
        password: z
            .string({ message: "Password is required" })
            .min(8, { message: "Password must be at least 8 characters long" })
            .regex(/[A-Z]/, {
                message: "Password must contain at least one uppercase letter",
            })
            .regex(/[a-z]/, {
                message: "Password must contain at least one lowercase letter",
            })
            .regex(/[0-9!@#$%^&*(),.?":{}|<>]/, {
                message:
                    "Password must contain at least one number or special character",
            }),
        newPassword: z
            .string({ message: "Password is required" })
            .min(8, { message: "Password must be at least 8 characters long" })
            .regex(/[A-Z]/, {
                message: "Password must contain at least one uppercase letter",
            })
            .regex(/[a-z]/, {
                message: "Password must contain at least one lowercase letter",
            })
            .regex(/[0-9!@#$%^&*(),.?":{}|<>]/, {
                message:
                    "Password must contain at least one number or special character",
            }),
        passwordRepeat: z.string({
            message: "Please repeat your password",
        }),
    })
    .refine((data) => data.newPassword === data.passwordRepeat, {
        message: "Passwords do not match",
        path: ["passwordRepeat"],
    });
